module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAABNUlEQVQ4T7XUzSutURjG4WuHlEiKkpEylNSJTDDilETKQEbKjEz9FcYyM5WBEklhxJmIlGSozJyiJFLy2ar3LXb7/di7rOm67996nvXcaxWkryp0R5JzvCfJCxmgP5iINJs4qwTUhRHUR+Yn7OKiFKxURdWYRGfC6ZfYwNv3/VKgv+jPaPkI+2mgFiwg6+4+sIzbGFZsGMBwRjXx9h7+JYFG0ZcTdIydJNAYenOCTrD966CplLEXFxpisJ5U0Txac7Z2g5VSoJDgxRyjj72fWEJI/I+8DGEwZzWx7BAH30HNmENNmaDXqL27EMg2TKOxTEgsf8BaAM2go0JIbLsKoLpoUi8VwmrxP+1xhgOaiuD3eM77H8W6dswWmVZxXS4o6MfRExlPsZXUfta/E3wNkfkx7Q6/AG/OL5rCrYcGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/bell.png
// module id = o9EK
// module chunks = 1